import { api, enc } from '../api';
import { fmtDate, fmtWhen } from '../format';
import { useApp, useLoad } from '../state';
import { Empty, Facts, Ladder, LedgerList, Loading, MidDisplay, MoveButtons, Notes, PageHead, Ref, Sub, useMoveDialog } from '../ui/bits';
import { useCampaignDialogs } from './dialogs';
import { HubSpotSection } from './HubSpot';
import { LinksAndPages } from './Web';

export function TrackDetail({ tid }: { tid: string }) {
  const { can } = useApp();
  const { editTrack } = useCampaignDialogs();
  const moveDialog = useMoveDialog();
  const { data: d, error, reload } = useLoad(() => api('GET', `/tracks/${enc(tid)}`), [tid]);
  if (error) return <Empty>{error}</Empty>;
  if (!d) return <Loading />;
  const t = d.track;
  return (<>
    <PageHead pre={<><div className="muted small"><Ref to={`#/campaigns/${t.mid}`}>{t.mid}</Ref> · {d.campaign?.name || ''}</div><MidDisplay id={t.tid} /></>}
      title={t.name} sub={<>{t.track_type_name || ''}{t.channel_name ? ` · ${t.channel_name}` : ''} · tracking {t.tracking_mode}</>}
      actions={can('contributor') && <button className="quiet" onClick={() => editTrack(t, reload)}>Edit track</button>} />
    <Ladder current={t.status_code} moves={d.moves} />
    <div className="muted small">Now {t.status_name} since {fmtWhen(t.step_start)}{t.step_end ? `, due ${fmtDate(t.step_end)}` : ''}{t.actual_start ? ` · started ${fmtDate(t.actual_start)}` : ''}{t.actual_end ? ` · ended ${fmtDate(t.actual_end)}` : ''}</div>
    <MoveButtons moves={d.moves} onMove={(to) => moveDialog('track', t.tid, t.status_code, d.moves, reload, to)} />
    <div className="cols" style={{ marginTop: 22 }}>
      <div><section>
        <Facts items={[
          ['Owner', <>{t.owner_name || '—'}{d.assignments.length > 0 && <Sub>{d.assignments.map((a: any) => `${a.party_name} (${a.role})`).join(', ')}</Sub>}</>],
          ['Objective', t.objective || '—'],
          ['Planned', <>{fmtDate(t.planned_start)} → {fmtDate(t.planned_end)}</>],
          ['Delivery', <>{t.delivery_window || '—'}{t.cadence_detail ? ` · ${t.cadence_detail}` : ''}{t.volume_target ? ` · ${t.volume_target}` : ''}</>],
          ['Primary CTA', t.cta_primary || '—'],
          ['Secondary CTA', t.cta_secondary || '—'],
          ['Offer', t.offer_code || <span className="muted">inherits campaign</span>],
          ['Audience', t.audience_note || '—'],
        ]} />
        {t.description && <p style={{ marginTop: 10 }}>{t.description}</p>}
      </section></div>
      <aside className="side">
        <section><h3>Ledger</h3><LedgerList rows={d.ledger} /></section>
        <Notes notes={d.notes} entityType="track" entityId={t.id} onAdded={reload} />
      </aside>
    </div>
    <LinksAndPages kind="track" track={t} />
    <HubSpotSection kind="track" entityId={t.id} refId={t.tid} />
  </>);
}
